import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { StyledInputsContainer } from '../styles';

const SemanticSearchFormSection = ({ control, dense, errors }) => {
  const { t } = useTranslation();

  return (
    <StyledInputsContainer>
      <Box>
        <FormControlLabel
          label={t('search.semantic', { ns: 'fields' })}
          control={
            <Controller
              name="settings.query.jsonQuery.params.dense"
              control={control}
              render={({ field }) => (
                <Checkbox
                  {...field}
                  checked={field.value}
                  inputProps={{ 'aria-label': 'semantic search' }}
                  onChange={(e) => {
                    field.onChange(e.target.checked);
                  }}
                />
              )}
            />
          }
        />
      </Box>
      {dense && (
        <>
          <Box>
            <Controller
              name="settings.query.jsonQuery.params.denseField"
              control={control}
              defaultValue=""
              shouldUnregister
              render={({ field }) => (
                <TextField
                  {...field}
                  label={t('search.denseField', { ns: 'fields' })}
                  variant="outlined"
                  size="small"
                  fullWidth
                  inputProps={{ 'aria-label': 'dense field' }}
                  error={
                    !!errors?.settings?.query?.jsonQuery?.params?.denseField
                  }
                  helperText={
                    errors?.settings?.query?.jsonQuery?.params?.denseField
                      ?.message
                  }
                />
              )}
            />
          </Box>

          <Box>
            <Controller
              name="settings.query.jsonQuery.params.denseTopK"
              control={control}
              defaultValue=""
              shouldUnregister
              render={({ field }) => (
                <TextField
                  {...field}
                  label={t('search.denseK', { ns: 'fields' })}
                  variant="outlined"
                  size="small"
                  fullWidth
                  inputProps={{ 'aria-label': 'denseK' }}
                  error={
                    !!errors?.settings?.query?.jsonQuery?.params?.denseTopK
                  }
                  helperText={
                    errors?.settings?.query?.jsonQuery?.params?.denseTopK
                      ?.message
                  }
                />
              )}
            />
          </Box>
        </>
      )}
    </StyledInputsContainer>
  );
};

SemanticSearchFormSection.propTypes = {
  control: PropTypes.object.isRequired,
  dense: PropTypes.bool,
  errors: PropTypes.object.isRequired,
};

export default SemanticSearchFormSection;
